module.exports = __webpack_public_path__ + "static/media/btp-mobile-logo.844ffb3c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/btp-mobile-logo.svg
// module id = 435
// module chunks = 1